import { withSameDayDeliveryProps } from 'viewModel/productPage/deliveryOptions/sameDayDelivery/withSameDayDeliveryProps';
import SameDayDelivery from 'components/ProductPage/DeliveryOptions/SameDayDelivery/SameDayDelivery';

export default withSameDayDeliveryProps(SameDayDelivery);
